import Path from "../../../services/paths";
import PratDashboardActions from "../../prat_actions/pratDashboard/pratDashboardActions";
import utils from "../../common/utils";
import axios from "axios";
import CustomToast from '../../../util-functions/customToast.jsx'

class PratDashboardMiddleware {
  static getMapCategories() {

    return dispatch => {
      dispatch(PratDashboardActions.mapCategoryRequest());

      utils
        .get_token()
        .then(token => {
          axios({
            method: "GET",
            url: Path.MAP_CATEGORIES,
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`
            }
          })
            .then(res => {
              if (res.status === 404) {
                throw('error')       // eslint-disable-line
              } else {
                dispatch(PratDashboardActions.mapCategorySuccessul(res));
              }
            })
            .catch(error => {
                if(error.response.status===401){
                  localStorage.clear();
                  window.location.reload();
                }
              dispatch(PratDashboardActions.mapCategoryFailed());
            });
        })
        .catch(error => {
          dispatch(PratDashboardActions.mapCategoryFailed(error));
        });
    };
  }

  static getActivationMetrics(
    selectedCategory,
    selectedYear,
    selectedMonth,
    selectedPromoType
  ) {

    let url = `${Path.ACTIVATION_METRICS}?`;

    if (Array.isArray(selectedCategory)) {
      selectedCategory.forEach(element => {
        url += `map_category=${element}&`;
      });
    }

    if (Array.isArray(selectedYear)) {
      selectedYear.forEach(element => {
        url += `year=${element}&`;
      });
    }

    if (Array.isArray(selectedMonth)) {
      selectedMonth.forEach(element => {
        url += `month=${element}&`;
      });
    }

    if (Array.isArray(selectedPromoType)) {
      selectedPromoType.forEach(element => {
        url += `promotion_type=${element}&`;
      });
    }

    url = url.slice(0, -1);

    return dispatch => {
      dispatch(PratDashboardActions.activationMetricsRequest());

      utils
        .get_token()
        .then(token => {
          axios({
            method: "GET",
            url: url,
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`
            }
          })
            .then(res => {
              if (res.status === 404) {
                dispatch(PratDashboardActions.activationMetricsFailed());
              } else {
                dispatch(PratDashboardActions.activationMetricsSuccessul(res));
              }
            })
            .catch(error => {
              dispatch(PratDashboardActions.activationMetricsFailed());
            });
        })
        .catch(error => {
          dispatch(PratDashboardActions.activationMetricsFailed(error));
        });
    };

  }

  static getTopActivites(
    selectedCategory,
    selectedPromoType,
    selectedBrands,
    selectedWeekFrom,
    selectedWeekTo
  ) {

    let url = `${Path.TOP_TEN_ACTIVITIES_PRAT_DASH}?`;

    // let url = 'https://api-unilever.nexdegree.com/b/v1/prepost_opso/top_10_activities/?';

    if (Array.isArray(selectedCategory)) {
      selectedCategory.forEach(element => {
        url += `map_category=${element}&`;
      });
    }

    if (Array.isArray(selectedBrands)) {
      selectedBrands.forEach(element => {
        url += `brand=${element}&`;
      });
    }

    if (Array.isArray(selectedPromoType)) {
      selectedPromoType.forEach(element => {
        url += `promotion_type=${element}&`;
      });
    }

    if (selectedWeekFrom) {
      url += `week_from=${selectedWeekFrom}&`;
    }

    if (selectedWeekTo) {
      url += `week_to=${selectedWeekTo}&`;
    }

    url = url.slice(0, -1);

    return dispatch => {
      dispatch(PratDashboardActions.topActivitiesRequest());

      utils
        .get_token()
        .then(token => {
          axios({
            method: "GET",
            url: url,
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`
            }
          })
            .then(res => {
              if (res.status === 404) {
                dispatch(PratDashboardActions.topActivitiesFailed());
              } else {
                dispatch(PratDashboardActions.topActivitiesSuccessul(res));
              }
            })
            .catch(error => {
              dispatch(PratDashboardActions.topActivitiesFailed());
            });
        })
        .catch(error => {
          dispatch(PratDashboardActions.topActivitiesFailed(error));
        });
    };

  }


  static getPostOpsoResult(
    selectedCategory
  ) {

    let url = `${Path.POST_OPSO_RESULT_PRAT_DASH}?`;

    if (Array.isArray(selectedCategory)) {
      selectedCategory.forEach(element => {
        url += `map_category=${element}&`;
      });
    }

    url = url.slice(0, -1);

    return dispatch => {
      dispatch(PratDashboardActions.postOpsoRequest());

      utils
        .get_token()
        .then(token => {
          axios({
            method: "GET",
            url: url,
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`
            }
          })
            .then(res => {
              if (res.status === 404) {
                dispatch(PratDashboardActions.postOpsoFailed());
              } else {
                dispatch(PratDashboardActions.postOpsoSuccessul(res));
              }
            })
            .catch(error => {
              dispatch(PratDashboardActions.postOpsoFailed());
            });
        })
        .catch(error => {
          dispatch(PratDashboardActions.postOpsoFailed(error));
        });
    };

  }

  static getTopBottomActivites(
    selectedCategory,
    selectedYear,
    selectedMonth,
    selectedPromoType
  ) {

    let url = `${Path.TOP_BOTTOM_ACTIVITIES_PRAT_DASH}?`;

    if (Array.isArray(selectedCategory)) {
      selectedCategory.forEach(element => {
        url += `map_category=${element}&`;
      });
    }

    if (Array.isArray(selectedYear)) {
      selectedYear.forEach(element => {
        url += `year=${element}&`;
      });
    }

    if (Array.isArray(selectedMonth)) {
      selectedMonth.forEach(element => {
        url += `month=${element}&`;
      });
    }

    if (Array.isArray(selectedPromoType)) {
      selectedPromoType.forEach(element => {
        url += `promotion_type=${element}&`;
      });
    }

    url = url.slice(0, -1);

    return dispatch => {
      dispatch(PratDashboardActions.topBottomActivitiesRequest());

      utils
        .get_token()
        .then(token => {
          axios({
            method: "GET",
            url: url,
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`
            }
          })
            .then(res => {
              if (res.status === 404) {
                dispatch(PratDashboardActions.topBottomActivitiesFailed());
              } else {
                dispatch(PratDashboardActions.topBottomActivitiesSuccessul(res));
              }
            })
            .catch(error => {
              dispatch(PratDashboardActions.topBottomActivitiesFailed());
            });
        })
        .catch(error => {
          dispatch(PratDashboardActions.topBottomActivitiesFailed(error));
        });
    };

  }


  static getTTSChart(
    selectedCategory
  ) {

    let url = `${Path.TTS_CHART}?`;

    if (Array.isArray(selectedCategory)) {
      selectedCategory.forEach(element => {
        url += `map_category=${element}&`;
      });
    }

    url = url.slice(0, -1);

    return dispatch => {
      dispatch(PratDashboardActions.ttsChartRequest());

      utils
        .get_token()
        .then(token => {
          axios({
            method: "GET",
            url: url,
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`
            }
          })
            .then(res => {
              if (res.status === 404) {
                dispatch(PratDashboardActions.ttsChartFailed());
              } else {
                dispatch(PratDashboardActions.ttsChartSuccessul(res));
              }
            })
            .catch(error => {
              dispatch(PratDashboardActions.ttsChartFailed());
            });
        })
        .catch(error => {
          dispatch(PratDashboardActions.ttsChartFailed(error));
        });
    };

  }

  static getDTTSChart(
    selectedCategory,
    selectedYear,
    selectedPromoType
  ) {

    let url = `${Path.DTTS_CHART}?`;

    if (Array.isArray(selectedCategory)) {
      selectedCategory.forEach(element => {
        url += `map_category=${element}&`;
      });
    }

    if (Array.isArray(selectedYear)) {
      selectedYear.forEach(element => {
        url += `year=${element}&`;
      });
    }

    if (Array.isArray(selectedPromoType)) {
      selectedPromoType.forEach(element => {
        url += `promotion_type=${element}&`;
      });
    }

    url = url.slice(0, -1);

    return dispatch => {
      dispatch(PratDashboardActions.dttsChartRequest());

      utils
        .get_token()
        .then(token => {
          axios({
            method: "GET",
            url: url,
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`
            }
          })
            .then(res => {
              if (res.status === 404) {
                dispatch(PratDashboardActions.dttsChartFailed());
              } else {
                dispatch(PratDashboardActions.dttsChartSuccessul(res));
              }
            })
            .catch(error => {
              dispatch(PratDashboardActions.dttsChartFailed());
            });
        })
        .catch(error => {
          dispatch(PratDashboardActions.dttsChartFailed(error));
        });
    };

  }

  static getGTMTSplit(
    selectedCategory,
    selectedYear,
    selectedMonth,
    selectedMasterChannel
  ) {

    let url = `${Path.GT_MT_SPLIT}?`;

    if (Array.isArray(selectedCategory)) {
      selectedCategory.forEach(element => {
        url += `map_category=${element}&`;
      });
    }

    if (Array.isArray(selectedYear)) {
      selectedYear.forEach(element => {
        url += `year=${element}&`;
      });
    }

    if (Array.isArray(selectedMonth)) {
      selectedMonth.forEach(element => {
        url += `month=${element}&`;
      });
    }

    if (Array.isArray(selectedMasterChannel)) {
      selectedMasterChannel.forEach(element => {
        url += `master_channel=${element}&`;
      });
    }

    url = url.slice(0, -1);

    return dispatch => {
      dispatch(PratDashboardActions.gtmtSplitChartRequest());

      utils
        .get_token()
        .then(token => {
          axios({
            method: "GET",
            url: url,
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`
            }
          })
            .then(res => {
              if (res.status === 404) {
                dispatch(PratDashboardActions.gtmtSplitChartFailed());
              } else {
                dispatch(PratDashboardActions.gtmtSplitChartSuccessul(res));
              }
            })
            .catch(error => {
              dispatch(PratDashboardActions.gtmtSplitChartFailed());
            });
        })
        .catch(error => {
          dispatch(PratDashboardActions.gtmtSplitChartFailed(error));
        });
    };

  }

  static getChannelUtilization(
    selectedCategory,
    selectedYearFrom,
    selectedYearTo,
    selectedMonthFrom,
    selectedMonthTo
  ) {

    let url = `${Path.CHANNEL_UTILIZATION}?`;

    if (Array.isArray(selectedCategory)) {
      selectedCategory.forEach(element => {
        url += `map_category=${element}&`;
      });
    }

    if (selectedYearFrom) {
      url += `year_from=${selectedYearFrom}&`;
    }

    if (selectedYearTo) {
      url += `year_to=${selectedYearTo}&`;
    }

    // if (selectedMonthFrom) {
    //   url += `month_from=${selectedMonthFrom}&`;
    // }

    if (Array.isArray(selectedMonthFrom)) {
      selectedMonthFrom.forEach(element => {
        url += `month_from=${element}&`;
      });
    }

    // if (selectedMonthTo) {
    //   url += `month_to=${selectedMonthTo}&`;
    // }

    if (Array.isArray(selectedMonthTo)) {
      selectedMonthTo.forEach(element => {
        url += `month_to=${element}&`;
      });
    }

    url = url.slice(0, -1);

    return dispatch => {
      dispatch(PratDashboardActions.channelUtilizationRequest());

      utils
        .get_token()
        .then(token => {
          axios({
            method: "GET",
            url: url,
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`
            }
          })
            .then(res => {
              if (res.status === 404) {
                dispatch(PratDashboardActions.channelUtilizationFailed());
              } else {
                dispatch(PratDashboardActions.channelUtilizationSuccessul(res));
              }
            })
            .catch(error => {
              dispatch(PratDashboardActions.channelUtilizationFailed());
            });
        })
        .catch(error => {
          dispatch(PratDashboardActions.channelUtilizationFailed(error));
        });
    };
  }
  
  static downloadDttsXlsx(
    selectedCategory,
  ) {
    let url = `${Path.DOWNLOAD_DTTS_XLSX}?`;

    if (Array.isArray(selectedCategory)) {
      selectedCategory.forEach(element => {
        url += `map_category=${element}&`;
      });
    }

    url = url.slice(0, -1);
    return dispatch => {
      dispatch(PratDashboardActions.dttsXlsxDownloadRequest());

      utils
        .get_token()
        .then(token => {
          axios({
            method: "GET",
            url: url,
            responseType: 'blob',
            headers: {
              "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              Authorization: `Bearer ${token}`
            }
          })
            .then(res => {
              if (res.status === 200) {
                let fileName = res.headers['content-disposition'].slice(res.headers['content-disposition'].indexOf('=') + 1)
                const url = window.URL.createObjectURL(new Blob([res.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', fileName); //or any other extension
                document.body.appendChild(link);
                link.click();
                CustomToast('success', 'Download Successful')
                dispatch(PratDashboardActions.dttsXlsxDownloadSuccessul(res));
              } else {
                CustomToast('error', 'Download Failed!')
                dispatch(PratDashboardActions.dttsXlsxDownloadFailed('error'));
              }
            })
            .catch(error => {
              CustomToast('error', 'Download Failed!')
              dispatch(PratDashboardActions.dttsXlsxDownloadFailed(error));
            });
        })
        .catch(error => {
          dispatch(PratDashboardActions.dttsXlsxDownloadFailed(error));
        });
    };
  }
  
  static downloadChannelUtiXlsx(
    selectedCategory,
  ) {
    let url = `${Path.DOWNLOAD_CHANNEL_UTI_XLSX}?`;

    if (Array.isArray(selectedCategory)) {
      selectedCategory.forEach(element => {
        url += `map_category=${element}&`;
      });
    }

    url = url.slice(0, -1);
    return dispatch => {
      dispatch(PratDashboardActions.channelUtiXlsxDownloadRequest());

      utils
        .get_token()
        .then(token => {
          axios({
            method: "GET",
            url: url,
            responseType: 'blob',
            headers: {
              "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              Authorization: `Bearer ${token}`
            }
          })
            .then(res => {
              if (res.status === 200) {
                let fileName = res.headers['content-disposition'].slice(res.headers['content-disposition'].indexOf('=') + 1)
                const url = window.URL.createObjectURL(new Blob([res.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', fileName); //or any other extension
                document.body.appendChild(link);
                link.click();
                CustomToast('success', 'Download Successful')
                dispatch(PratDashboardActions.channelUtiXlsxDownloadSuccessul(res));
              } else {
                CustomToast('error', 'Download Failed!')
                dispatch(PratDashboardActions.channelUtiXlsxDownloadFailed('error'));
              }
            })
            .catch(error => {
              CustomToast('error', 'Download Failed!')
              dispatch(PratDashboardActions.channelUtiXlsxDownloadFailed(error));
            });
        })
        .catch(error => {
          dispatch(PratDashboardActions.channelUtiXlsxDownloadFailed(error));
        });
    };
  }
  
  static downloadTtsXlsx(
    selectedCategory,
  ) {
    let url = `${Path.DOWNLOAD_TTS_XLSX}?`;

    if (Array.isArray(selectedCategory)) {
      selectedCategory.forEach(element => {
        url += `map_category=${element}&`;
      });
    }

    url = url.slice(0, -1);
    return dispatch => {
      dispatch(PratDashboardActions.ttsXlsxDownloadRequest());

      utils
        .get_token()
        .then(token => {
          axios({
            method: "GET",
            url: url,
            responseType: 'blob',
            headers: {
              "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              Authorization: `Bearer ${token}`
            }
          })
            .then(res => {
              if (res.status === 200) {
                let fileName = res.headers['content-disposition'].slice(res.headers['content-disposition'].indexOf('=') + 1)
                const url = window.URL.createObjectURL(new Blob([res.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', fileName); //or any other extension
                document.body.appendChild(link);
                link.click();
                CustomToast('success', 'Download Successful')
                dispatch(PratDashboardActions.ttsXlsxDownloadSuccessul(res));
              } else {
                CustomToast('error', 'Download Failed!')
                dispatch(PratDashboardActions.ttsXlsxDownloadFailed('error'));
              }
            })
            .catch(error => {
              CustomToast('error', 'Download Failed!')
              dispatch(PratDashboardActions.ttsXlsxDownloadFailed(error));
            });
        })
        .catch(error => {
          dispatch(PratDashboardActions.ttsXlsxDownloadFailed(error));
        });
    };
  }
  
  static downloadActivationMetXlsx(
    selectedCategory,
    selectedYear,
    selectedMonth,
    selectedPromoType
  ) {
    let url = `${Path.DOWNLOAD_ACTIVATION_MET_XLSX}?`;

    if (Array.isArray(selectedCategory)) {
      selectedCategory.forEach(element => {
        url += `map_category=${element}&`;
      });
    }

    if (Array.isArray(selectedYear)) {
      selectedYear.forEach(element => {
        url += `year=${element}&`;
      });
    }

    if (Array.isArray(selectedMonth)) {
      selectedMonth.forEach(element => {
        url += `month=${element}&`;
      });
    }

    if (Array.isArray(selectedPromoType)) {
      selectedPromoType.forEach(element => {
        url += `promotion_type=${element}&`;
      });
    }

    url = url.slice(0, -1);
    return dispatch => {
      dispatch(PratDashboardActions.activationMetXlsxDownloadRequest());

      utils
        .get_token()
        .then(token => {
          axios({
            method: "GET",
            url: url,
            responseType: 'blob',
            headers: {
              "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              Authorization: `Bearer ${token}`
            }
          })
            .then(res => {
              if (res.status === 200) {
                let fileName = res.headers['content-disposition'].slice(res.headers['content-disposition'].indexOf('=') + 1)
                const url = window.URL.createObjectURL(new Blob([res.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', fileName); //or any other extension
                document.body.appendChild(link);
                link.click();
                CustomToast('success', 'Download Successful')
                dispatch(PratDashboardActions.activationMetXlsxDownloadSuccessul(res));
              } else {
                CustomToast('error', 'Download Failed!')
                dispatch(PratDashboardActions.activationMetXlsxDownloadFailed('error'));
              }
            })
            .catch(error => {
              CustomToast('error', 'Download Failed!')
              dispatch(PratDashboardActions.activationMetXlsxDownloadFailed(error));
            });
        })
        .catch(error => {
          dispatch(PratDashboardActions.activationMetXlsxDownloadFailed(error));
        });
    };
  }
}

export default PratDashboardMiddleware;
